import { Rescatable } from '../Rescatable';
import { Subcategory } from './Subcategory';

export class SubcategoryGrouper extends Rescatable {
  static _name = 'SubcategoryGrouper';
  static pathRequest = Rescatable.pathRequestStatic + 'subcategoriasAgrupadores';
  static pk: keyof SubcategoryGrouper = 'id';

  id: number;
  nombre: string;
  orden: number;
  $subcatgories?: Subcategory[];
  constructor(subcategoryGrouper: SubcategoryGrouper) {
    super(subcategoryGrouper);
  }
}
